<template>
    <div>
        <!-- ============================================================== -->
        <!-- Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <div class="page-breadcrumb border-bottom">
            <div class="row">
                <div class="col-lg-3 col-md-4 col-xs-12 align-self-center">
                    <h5 class="mb-0 font-medium text-uppercase">Template Community Managers <span
                            class="badge badge-primary">{{ count }}</span></h5>
                </div>
                <div class="col-lg-9 col-md-8 col-xs-12 align-self-center">
                    <nav aria-label="breadcrumb" class="float-left mt-2 float-md-right">
                        <ol class="p-0 mb-0 breadcrumb justify-content-end">
                            <li class="breadcrumb-item">
                                <a>Home</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Template Community Managers</li>
                        </ol>
                    </nav>
                </div>
            </div>
        </div>
        <!-- ============================================================== -->
        <!-- End Bread crumb and right sidebar toggle -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Container fluid  -->
        <!-- ============================================================== -->
        <div class="page-content container-fluid">
            <!-- ============================================================== -->
            <!-- Start Page Content -->
            <!-- ============================================================== -->

            <div class="row">
                <div class="col-12">
                    <div class="card">
                        <div class="card-body">
                            <!-- <div class="row">
                              <div class="form-group col-4">
                                <div class="input-group">
                                  <span class="input-group-btn">
                                    <button type="button" class="btn waves-effect waves-light btn-info">
                                      <i class="fa fa-search"></i>
                                    </button>
                                  </span>
                                  <input type="text" class="form-control" placeholder="Search by email" @change="searchUser()" v-model="textSearch"/>
                                </div>
                              </div>
                            </div> -->
                            <div class="table-responsive">
                                <div class="text-center">
                                    <i class="fa fa-spinner fa-spin" v-if="isLoading"></i>
                                </div>
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Access Code</th>
                                        <th>Copy count</th>
                                        <th>Slide count</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr
                                            :key="index"
                                            v-for="(item, index) in items"
                                            @click="openDetailTemplate(item)"
                                            class="pointer"
                                    >
                                        <td>{{ item.id }}</td>
                                        <td>{{ item.name }}</td>

                                        <td>{{ item.accessCode }}</td>
                                        <td>{{ item.copyCount }}</td>
                                        <td>{{ item.slideCount }}</td>
                                    </tr>
                                    </tbody>
                                </table>

                                <div class="overflow-auto">
                                    <b-pagination v-model="page" :total-rows="count" per-page="30"></b-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import Config from "@/config";
import backdoor from '@/services/backdoor'

export default {
  name: "Templates",
  data() {
    return {
      items: [],
      page: 1,
      count: 0,
      isLoading: false,
      textSearch: "",
    };
  },
  created() {
    this.getData();
  },
  mounted() {
  },
  watch: {
    page: {
      handler: function () {
        this.getData();
      },
      deep: true
    }
  },
  methods: {
    searchUser() {
      this.getData();
    },
    buildTemplate(data) {
      const listPresentation = [];
      if (data && data.PresentationsCategories) {
        const presentationCategories = data.PresentationsCategories
        presentationCategories.forEach((presentationCategory) => {
          listPresentation.push(presentationCategory.Presentation)
        })
      }
      return listPresentation
    },
    getData() {
      this.isLoading = true;
      let params = {
        page: this.page,
        limit: 30,
      };
      this.$http
        .get(Config.api.adminGetTemplateCommunities, {
          params: params
        })
        .then(async res => {
          this.items = await this.buildTemplate(res.body.data[0])
          this.count = res.body.total;
          this.isLoading = false;
        });
    },
    openDetailTemplate(item) {
      this.$router.push({name: "TemplateCommunitiesDetail", params: {id: item.id}});
    },

    async goToPresenterSide(item) {
      if (item.isLoading) return;
      item.isLoading = true;
      try {
        await backdoor.openPresenterAs(item.id)
      } finally {
        item.isLoading = false;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
// .addUser-btn {
//   background-color: #4f9af2;
//   border-radius: 20px;
//   border-color: #4f9af2;
//   &:hover {
//     background-color: #2785f0;
//     border-color: #2785f0;
//   }
// }
</style>
